import { useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import ESpinner from 'components/others/Spinner';
import TitleCounter from 'components/others/TitleCounter';
import { NewObjectModal, type NewObjectType } from 'modules/lead';
import { OffNewSale, type NewSaleType } from 'modules/objects';
import OffClientCustomerEdit from '../OffClientCustomers/OffClientCustomerEdit';
import CustomersListToolBar from './CustomersListToolBar';
import CustomersListTable from './CustomersListTable';
import useCustomersListPage from './model/useCustomersListPage';

const CustomersList = () => {
    const { t } = useTranslation(['Clients']);
    const {
        list,
        editCustomer,
        isCreate,
        formNonce,
        handleHideEdit,
        handleCreate,
        handleEdit,
        handleDelete,
        handleSaved,
    } = useCustomersListPage();
    const [newSale, setNewSale] = useState<NewSaleType | null>(null);
    const [newObject, setNewObject] = useState<NewObjectType | null>(null);

    return (
        <>
            <OffClientCustomerEdit
                clientId={isCreate ? null : editCustomer?.clientId ?? null}
                customer={editCustomer}
                isCreate={isCreate}
                formNonce={formNonce}
                onHide={handleHideEdit}
                onSaved={handleSaved}
            />
            <OffNewSale newSale={newSale} setNewSale={setNewSale} />
            <NewObjectModal newObject={newObject} setNewObject={setNewObject} />

            <Row>
                <Col className="col-sticky" sm={12}>
                    <div className="w-100 d-sm-flex pt-1 justify-content-between align-items-start">
                        <div>
                            <h4 className="p-0 m-0 mb-0 me-2 text-break">{t('subjects.registryTitle')}</h4>
                            <TitleCounter />
                        </div>
                        <div className="mt-2 mt-sm-0">
                            <CustomersListToolBar onCreate={handleCreate} />
                        </div>
                    </div>
                </Col>

                <Col sm={12}>
                    {list ? (
                        <CustomersListTable
                            rows={list}
                            onEdit={handleEdit}
                            onDelete={handleDelete}
                            onCreateSale={setNewSale}
                            onCreateObject={setNewObject}
                        />
                    ) : (
                        <ESpinner />
                    )}
                </Col>
            </Row>
        </>
    );
};

export default CustomersList;
